export const KP_AYANAMSHA_PREFERENCE_TRANSLATIONS: Record<string, Record<string, string>> = {
  "hi": {
    "Use KP Ayanamsha for KP and Nadi": "KP और नाड़ी के लिए KP अयनांश का उपयोग करें",
    "Uncheck to use the selected Ayanamsha for all calculations, including KP and Nadi.": "इसे अनचेक करने पर चुना गया अयनांश KP और नाड़ी सहित सभी गणनाओं में लागू होगा।"
  },
  "ta": {
    "Use KP Ayanamsha for KP and Nadi": "நாடி மற்றும் KP க்கு KP அயனாம்சம் பயன்படுத்தவும்",
    "Uncheck to use the selected Ayanamsha for all calculations, including KP and Nadi.": "இதைத் தேர்வுநீக்கினால், KP மற்றும் நாடி உட்பட அனைத்து கணக்கீடுகளுக்கும் தேர்ந்தெடுத்த அயனாம்சம் பயன்படுத்தப்படும்."
  },
  "te": {
    "Use KP Ayanamsha for KP and Nadi": "నాడి మరియు KP కోసం KP అయనాంశం ఉపయోగించండి",
    "Uncheck to use the selected Ayanamsha for all calculations, including KP and Nadi.": "దీన్ని అన్‌చెక్ చేస్తే, KP మరియు నాడితో సహా అన్ని గణనలకు ఎంచుకున్న అయనాంశం ఉపయోగించబడుతుంది."
  },
  "mr": {
    "Use KP Ayanamsha for KP and Nadi": "नाडी आणि KP साठी KP अयनांश वापरा",
    "Uncheck to use the selected Ayanamsha for all calculations, including KP and Nadi.": "हे अनचेक केल्यास निवडलेला अयनांश KP आणि नाडीसह सर्व गणनांसाठी वापरला जाईल."
  },
  "gu": {
    "Use KP Ayanamsha for KP and Nadi": "નાડી અને KP માટે KP અયનાંશ વાપરો",
    "Uncheck to use the selected Ayanamsha for all calculations, including KP and Nadi.": "આને અનચેક કરવાથી પસંદ કરેલ અયનાંશ KP અને નાડી સહિત બધી ગણતરીઓ માટે વપરાશે."
  },
  "bn": {
    "Use KP Ayanamsha for KP and Nadi": "নাড়ি এবং KP-এর জন্য KP অয়নাংশ ব্যবহার করুন",
    "Uncheck to use the selected Ayanamsha for all calculations, including KP and Nadi.": "এটি আনচেক করলে KP ও নাড়ি সহ সব গণনায় নির্বাচিত অয়নাংশ ব্যবহার হবে।"
  },
  "kn": {
    "Use KP Ayanamsha for KP and Nadi": "ನಾಡಿ ಮತ್ತು KP ಗೆ KP ಅಯನಾಂಶ ಬಳಸಿ",
    "Uncheck to use the selected Ayanamsha for all calculations, including KP and Nadi.": "ಇದನ್ನು ಅನ್‌ಚೆಕ್ ಮಾಡಿದರೆ, KP ಮತ್ತು ನಾಡಿ ಸೇರಿದಂತೆ ಎಲ್ಲಾ ಲೆಕ್ಕಾಚಾರಗಳಿಗೆ ಆಯ್ದ ಅಯನಾಂಶ ಬಳಸಲಾಗುತ್ತದೆ."
  },
  "ml": {
    "Use KP Ayanamsha for KP and Nadi": "നാടി, KP എന്നിവയ്ക്ക് KP അയനാംശം ഉപയോഗിക്കുക",
    "Uncheck to use the selected Ayanamsha for all calculations, including KP and Nadi.": "ഇത് അൺചെക്ക് ചെയ്താൽ, KP, നാടി ഉൾപ്പെടെ എല്ലാ കണക്കുകൂട്ടലുകൾക്കും തിരഞ്ഞെടുത്ത അയനാംശം ഉപയോഗിക്കും."
  },
  "pa": {
    "Use KP Ayanamsha for KP and Nadi": "ਨਾਡੀ ਅਤੇ KP ਲਈ KP ਅਯਨਾਮਸ਼ਾ ਵਰਤੋ",
    "Uncheck to use the selected Ayanamsha for all calculations, including KP and Nadi.": "ਇਸ ਨੂੰ ਅਨਚੈੱਕ ਕਰਨ ਨਾਲ ਚੁਣਿਆ ਅਯਨਾਮਸ਼ਾ KP ਅਤੇ ਨਾਡੀ ਸਮੇਤ ਸਾਰੀਆਂ ਗਣਨਾਵਾਂ ਲਈ ਵਰਤਿਆ ਜਾਵੇਗਾ।"
  },
  "or": {
    "Use KP Ayanamsha for KP and Nadi": "ନାଡି ଏବଂ KP ପାଇଁ KP ଅୟନାଂଶ ବ୍ୟବହାର କରନ୍ତୁ",
    "Uncheck to use the selected Ayanamsha for all calculations, including KP and Nadi.": "ଏହାକୁ ଅନଚେକ୍ କଲେ KP ଏବଂ ନାଡି ସହିତ ସମସ୍ତ ଗଣନାରେ ଚୟନିତ ଅୟନାଂଶ ବ୍ୟବହାର ହେବ।"
  },
  "as": {
    "Use KP Ayanamsha for KP and Nadi": "নাড়ী আৰু KP ৰ বাবে KP অয়নাংশ ব্যৱহাৰ কৰক",
    "Uncheck to use the selected Ayanamsha for all calculations, including KP and Nadi.": "এইটো আনচেক কৰিলে KP আৰু নাড়ীকে ধৰি সকলো গণনাত নিৰ্বাচিত অয়নাংশ ব্যৱহাৰ হ’ব।"
  },
  "ur": {
    "Use KP Ayanamsha for KP and Nadi": "نادی اور KP کے لیے KP ایانامشا استعمال کریں",
    "Uncheck to use the selected Ayanamsha for all calculations, including KP and Nadi.": "اسے غیر منتخب کرنے پر KP اور نادی سمیت تمام حسابات میں منتخب ایانامشا استعمال ہوگا۔"
  }
};
